import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import profile from "../../../Assets/Images/profile.svg";
import { useGlobalContext } from "../../../Context/GlobalContext";
import { LinkOff } from "@mui/icons-material";

import Cookies from "js-cookie";
const AddOneStaff = () => {
  const navigate = useNavigate();
  const { baseUrl, openToast, fetchStaffs } = useGlobalContext();
  const [departments, setDepartments] = useState([]);
  const [roles, setRoles] = useState([]);
  const [name, setName] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [branch, setBranch] = useState([]);
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  console.log(typeof(otp))
  const [gender, setGender] = useState("default");
  const [email, setEmail] = useState("");
  const [date, setDate] = useState("");
  const [address, setAddress] = useState("");
  const [selectDepartment, setSelectDepartment] = useState("default");
  const [selectRole, setSelectRole] = useState("default");
  const [selectBranch, setSelectBranch] = useState("default");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  console.log(branch);

  const handleChange = (e) => {
    const value = e.target.value;

    // Allow only numbers
    if (!/^\d*$/.test(value)) return;

    if (value.length > 5) {
      return; // Prevent typing more than 5 digits
    }

    setOtp(value);

    // Validation for exact 5 digits
    if (value.length === 5) {
      setError("");
    } else {
      setError("OTP must be exactly 5 digits.");
    }
  };

  const fetchDepartments = async () => {
    try {
      const result = await fetch(baseUrl + "department", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      const res = await result.json();
      if (result.status == 200) {
        setDepartments(res.data);
      } else {
        console.log("error while fetching department", res.status);
        setDepartments([]);
      }
    } catch (error) {
      console.log("error", error.message);
      setDepartments([]);
    }
  };

  const fetchBranch = async () => {
    try {
      const result = await fetch(baseUrl + "branch", {
        headers: {
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
      });
      const res = await result.json();
      if (result.status == 200) {
        setBranch(res);
      } else {
        console.log("error while fetching department", res.status);
        setBranch([]);
      }
    } catch (error) {
      console.log("error", error.message);
      setDepartments([]);
    }
  };

  const fetchRoles = async () => {
    const result = await fetch(baseUrl + "role", {
      headers: {
        Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
      },
    });
    if (result.status == 200) {
      const res = await result.json();
      setRoles(res.data);
    } else {
      console.log("failed to fetch roles");
    }
    console.log("result", result);
  };

  console.log(selectBranch);
  useEffect(() => {
    fetchDepartments();
    fetchRoles();
    fetchBranch();
  }, []);

  async function handlesubmit(e) {
    e.preventDefault();
    console.log(otp.length)
    if (otp.length <5) {
      openToast("Please Enter Five Digit Login Token", "warning");
      return;
    }
    const data = {
      name: name,
      job_title: jobTitle,
      branch: branch,
      mobile: mobile,
      login_otp: otp,
      gender: gender,
      official_email: email,
      date_of_joining: date,
      current_address: address,
      departmentId: selectDepartment,
      roleId: selectRole,
      branchid: selectBranch,
    };
    setIsLoading(true);
    try {
      if (selectBranch === "default") {
        openToast("Please select branch", "warning");
        return;
      }
      if (selectRole === "default") {
        openToast("Please select role", "warning");
        return;
      }
      if (selectDepartment === "default") {
        openToast("Please select department", "warning");
        return;
      }
      if (gender === "default") {
        openToast("Please select gender", "warning");
        return;
      }
      const response = await fetch(baseUrl + "staff", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("flowChangerAuthToken")}`,
        },
        body: JSON.stringify(data), // send the formatted data
      });

      const result = await response.json();
      console.log("result issues", result.issues);
      if (response.status === 201) {
        setIsLoading(false);
        openToast("Add Staff Succesfully");
        navigate("/staff-menu");
        fetchStaffs();
        setName("");
        setJobTitle("");
        setBranch("");
        setMobile("");
        setOtp("");
        setGender("");
        setEmail("");
        setDate("");
        setAddress("");
        setSelectDepartment("");
        setSelectRole("");
      } else {
        openToast(result.message || "An Internal Error", "error");
        openToast(result.issues, "error");
      }
    } catch (error) {
      if (error.message === "Failed to fetch") {
        console.error("Network or CORS issue:", error);
        openToast(
          "Unable to connect to the server. Please check your internet connection or try again later.",
          "error"
        );
      } else {
        openToast("An unexpected error occurred. Please try again.", "error");
      }
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div className="add-one-staff">
      <Link
        to="/staff-menu"
        className="flex items-center gap-[10px] py-[12px] pl-[24px] font-medium text-[20px]"
      >
        <KeyboardBackspaceIcon />
        Add Staff
      </Link>
      <form
        onSubmit={handlesubmit}
        className="shadow-md m-auto mt-[60px] p-[12px] xl:p-[24px] border border-1 rounded-md w-[100%] xl:w-[80%]"
      >
        <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[6px] xl:mb-4 w-[100%]">
          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">Name</label>
            <br />
            <input
              type="text"
              value={name}
              placeholder="Enter Name"
              onChange={(e) => {
                setName(e.target.value);
              }}
              className="bg-[#fff] newcls-shadow focus:shadow-cs focus-visible:shadow-cs mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
              required
            />
          </div>

          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]" required>
              Job Tittle
            </label>
            <br />
            <input
              type="text"
              value={jobTitle}
              placeholder="Enter Job Title"
              onChange={(e) => {
                setJobTitle(e.target.value);
              }}
              className="bg-[#fff] newcls-shadow focus:shadow-cs focus-visible:shadow-cs mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
              required
            />
          </div>
        </div>

        <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[10px] w-[100%]">
          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">Branch</label>
            <br />
            <select
              onChange={(e) => setSelectBranch(e.target.value)}
              className="bg-[#fff] newcls-shadow focus:shadow-cs focus-visible:shadow-cs mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
              required
            >
              <option value={"default"}>Please Select Branch</option>
              {branch?.map((item, index) => {
                return <option value={item?.id}>{item?.branchName}</option>;
              })}
            </select>
          </div>

          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">Department</label>
            <br />
            <select
              value={selectDepartment}
              onChange={(e) => setSelectDepartment(e.target.value)}
              className="bg-[#fff] newcls-shadow focus:shadow-cs focus-visible:shadow-cs mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
              required
            >
              <option value={"default"}>Select Department</option>
              {departments?.map((dep, index) => {
                return (
                  <option key={dep.id} value={dep.id}>
                    {dep.department_name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[10px] w-[100%]">
          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">Role</label>
            <br />
            <select
              value={selectRole}
              onChange={(e) => setSelectRole(e.target.value)}
              className="bg-[#fff] newcls-shadow focus:shadow-cs focus-visible:shadow-cs mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
              required
            >
              <option value={"default"}> Select Role</option>
              {roles?.map((role, index) => {
                return (
                  <option key={role.id} value={role.id}>
                    {role.role_name}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">Mobile</label>
            <br />
            <input
              type="number"
              value={mobile}
              placeholder="Enter Mobile "
              onChange={(e) => {
                setMobile(e.target.value);
              }}
              className="bg-[#fff] newcls-shadow focus:shadow-cs focus-visible:shadow-cs mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
              required
            />
          </div>
        </div>

        <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[10px] w-[100%]">
          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">Login Token</label>
            <br />
            <input
              type="text"
              value={otp}
              placeholder="Login Token"
              onChange={handleChange}
              className="bg-[#fff] newcls-shadow focus:shadow-cs focus-visible:shadow-cs mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
              maxLength={5} // Ensures max 5 characters at the input level
            />
            {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
          </div>

          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">Gender</label>
            <br />
            <select
              value={gender}
              onChange={(e) => {
                setGender(e.target.value);
              }}
              className="bg-[#fff] newcls-shadow focus:shadow-cs focus-visible:shadow-cs mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
              required
            >
              <option value={"default"}>Select Gender</option>
              <option value={"Male"}>Male</option>
              <option value={"Female"}>Female</option>
            </select>
          </div>
        </div>

        <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[10px] w-[100%]">
          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">Official Email ID</label>
            <br />
            <input
              type="email"
              value={email}
              placeholder="Enter Email"
              onChange={(e) => {
                setEmail(e.target.value);
              }}
              className="bg-[#fff] newcls-shadow focus:shadow-cs focus-visible:shadow-cs mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
              required
            />
          </div>

          <div className="w-[100%] xl:w-[48%] 2xl:w-[48%]">
            <label className="text-[14px]">Date of Joining</label>
            <br />
            <input
              type="date"
              value={date}
              onClick={(e) => e.target.showPicker()}
              placeholder="Select Date"
              onChange={(e) => {
                setDate(e.target.value);
              }}
              className="bg-[#fff] newcls-shadow focus:shadow-cs focus-visible:shadow-cs mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
              required
            />
          </div>
        </div>

        <div className="flex xl:flex-row flex-col justify-between gap-[10px] mb-[10px] w-[100%]">
          <div className="w-[100%] xl:[48%]">
            <label className="text-[14px]">Address</label>
            <br />
            <input
              type="text"
              value={address}
              placeholder="Enter Address"
              onChange={(e) => {
                setAddress(e.target.value);
              }}
              className="bg-[#fff] newcls-shadow focus:shadow-cs focus-visible:shadow-cs mt-1 p-[5px] border border-1 rounded-md focus:outline-none w-[100%] placeholder:font-font-normal text-[#000] text-[14px]"
              required
            />
          </div>
        </div>

        <div className="flex justify-end mt-4 p-3">
          <div className="flex items-center gap-[20px]">
            <Link to="/staff-menu" className="flex items-center first-btn">
              Cancel
            </Link>
            <button
              className={` ${
                isLoading == true ? "second-btn-disabled" : "second-btn"
              }`}
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddOneStaff;
